export default __webpack_public_path__ + "locales/uk-UA/Article.json?hash=813e2ae76ca2666063d682c303369fe3";